import { ChatOptionItemProps } from './types';

export const ChatOptionItem = ({ children, onClick, optionName }: ChatOptionItemProps) => (
    <button
        type="button"
        onClick={onClick}
        className="w-full hover:bg-primary focus-visible:bg-primary hover:text-on-primary focus-visible:text-on-primary flex items-center text-sm text-left px-4 py-2 select-none transition-colors ease-in-out duration-200"
    >
        {children}
        {optionName}
    </button>
);
